import { Card, CardContent, CardHeader } from '@/components/ui/Card'
import { SectionEyebrow } from '@/components/ui/SectionEyebrow'
import { Text } from '@/components/ui/Text'

export function Day0LiveDashboardTile() {
  return (
    <Card data-testid="day0-live-dashboard-tile">
      <CardHeader className="py-4">
        <SectionEyebrow>LIVE DASHBOARD</SectionEyebrow>
      </CardHeader>
      <CardContent>
        <Text variant="body-sm" color="muted">
          Entities, jurisdictions, events, and filings activate when you go live.
        </Text>
      </CardContent>
    </Card>
  )
}
